import { Routes, Route } from 'react-router-dom';
import PackagesList from './components/PackagesList';
import PackagesForm from './components/PackagesForm';
import OverrideForm from './components/OverrideForm';
import PackagesLog from './components/PackagesLog';
import { AdminAclEnum } from '../../enum/AdminAclEnum';
import { hasAccessRight } from '../../utils/Functions';

export default function PackagesRoutes() {
    return (
        <Routes>
            {hasAccessRight(AdminAclEnum.PACKAGES) && (
                <>
                    <Route path="packages" element={<PackagesList />} />
                    <Route path="form/:packageId?" element={<PackagesForm />} />
                    <Route path="override" element={<OverrideForm />} />
                    <Route path="override/:id" element={<OverrideForm />} />
                    <Route path="log" element={<PackagesLog />} />
                    <Route path="log-packages" element={<PackagesLog />} />
                </>
            )}
        </Routes>
    );
}
